import React from "react";
import { useState } from "react";
import { Button, ButtonGroup, Card, CardBody, CardHeader, Col, FormGroup, Input, ListGroup, ListGroupItem, Row } from "reactstrap";
import selected_profile_avatar from 'assets/images/user-profile-sample.png'
import check_icon from 'assets/svgIcon/check_icon.svg'
import ReactQuill from "react-quill";
const PDScreenFour = (props)=>{
    const [stepFormCur, setStepFormCur] = useState(0);
    return (
        <><CardBody className={`nex-form-step ${stepFormCur == 0 ? 'active' : ''}`}>
        <br/>
        <div className="nex-form-field-container">
        <div className="nex-form-group nex-content-center">
            <div className="nex-form-group-c">
            <label htmlFor="" className="nex-big-label mb-3">Please Select Specialty and Practitioner from the Below Options </label>
            <FormGroup>
                <Input className="nex-form-control-blue" placeholder="Filter Specialty" />
            </FormGroup>

                <ul className="nex-check-lists">
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Academic Medicine</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Acupuncturist</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Acute Care Nurse Practitioner</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Aerospace Medicine</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Allergy & Immunology</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Alternative Medicine</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Academic Medicine</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Acupuncturist</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Acute Care Nurse Practitioner</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Aerospace Medicine</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Allergy & Immunology</a></li>
                    <li onClick={(e)=>props.goto(e, 5)}><i className="icon"><img src={check_icon} alt="" /></i><a> Alternative Medicine</a></li>
                </ul>
            </div>
        </div>
        </div>
        <div className="nex-form-group-c">
        <div className="nex-form-action">
            <Button
                color="primary"
                className="nexogic_primary_button_outline"
                onClick={(e)=>props.goBack(e, 3)}
            >
                Back
            </Button>
        </div>
        </div>


    </CardBody></>
    )
}
export default PDScreenFour;